import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useCustomerQuery } from '../../../api/customers';
import { useBoolean } from 'usehooks-ts';
import { UpdatedView } from './UpdatedView';
import { UpdateEmailForm } from './UpdateEmailForm';

export function UpdateEmailPage() {
  const { t } = useTranslation();
  const customerQuery = useCustomerQuery();
  const identity = customerQuery.data?.identity;
  const changedFlag = useBoolean(false);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={identity?.hasPassword ? t('Change email') : t('Set email')}
          parent={{
            to: '/account/settings',
            title: t('Settings'),
          }}
        />
      }
      compact
    >
      {identity ? (
        changedFlag.value ? (
          <UpdatedView text={t('Email successfully changed')} />
        ) : (
          <UpdateEmailForm identity={identity} onComplete={changedFlag.setTrue} />
        )
      ) : null}
    </MainLayout>
  );
}
